import { Button } from '@mui/material';
import { ComponentProps } from 'react';

export const getAcknowledgeButtonStyle = (): ComponentProps<typeof Button> => ({
  variant: 'contained',
  sx: {
    textTransform: 'none',
  },
});
